export enum PaperworkOrigin {
	Profile = "profile",
	More = "more",
}

export type PaperworkNavigationState = {
	paperworkFrom?: PaperworkOrigin;
};
